export const ResidentialBannerType = {
    "ACTIVATION": 0,
    "FIRST_ORDER": 1,
    "LOYALTY": 2,
    "LOYALTY_COMPLETE": 3,
    "SMS_OPT_IN": 4
  }